export default __webpack_public_path__ + "static/media/email.2fb920e0.svg";